if (!customElements.get('tabbed-image-carousel')) {
  class TabbedImageCarousel extends HTMLElement {
    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[data-tab-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

      if (!this.triggers.length || !this.panels.length) return;

      this.onClick = this.onClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.onClick);
        trigger.addEventListener('keydown', this.onKeyDown);
      });

      document.addEventListener('shopify:block:select', this.onBlockSelect);

      const activeIdx = this.triggers.findIndex(
        (trigger) => trigger.getAttribute('aria-selected') === 'true'
      );
      this.setActive(activeIdx === -1 ? 0 : activeIdx, false);
    }

    disconnectedCallback() {
      if (!this.onBlockSelect) return;

      this.triggers.forEach((trigger) => {
        trigger.removeEventListener('click', this.onClick);
        trigger.removeEventListener('keydown', this.onKeyDown);
      });

      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onClick(event) {
      this.setActive(this.triggers.indexOf(event.currentTarget), true);
    }

    onKeyDown(event) {
      const key = event.key;
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;

      event.preventDefault();
      const current = this.activeIndex ?? 0;
      let next = current;

      if (key === 'ArrowRight') {
        next = (current + 1) % this.triggers.length;
      } else if (key === 'ArrowLeft') {
        next = (current - 1 + this.triggers.length) % this.triggers.length;
      } else if (key === 'Home') {
        next = 0;
      } else if (key === 'End') {
        next = this.triggers.length - 1;
      }

      if (next !== current) {
        this.setActive(next, true);
      }
    }

    onBlockSelect(event) {
      if (!this.contains(event.target)) return;

      const panel = event.target.closest('[data-tab-panel]');
      if (panel) {
        const index = this.panels.indexOf(panel);
        if (index !== -1) this.setActive(index, false);
      }
    }

    setActive(index, shouldFocus) {
      if (this.activeIndex !== undefined) {
        this.triggers[this.activeIndex].setAttribute('aria-selected', 'false');
        this.triggers[this.activeIndex].setAttribute('tabindex', '-1');
        this.panels[this.activeIndex].hidden = true;
        this.panels[this.activeIndex].setAttribute('tabindex', '-1');
      }

      this.activeIndex = index;
      const trigger = this.triggers[index];
      const panel = this.panels[index];

      trigger.setAttribute('aria-selected', 'true');
      trigger.setAttribute('tabindex', '0');
      panel.hidden = false;
      panel.setAttribute('tabindex', '0');

      if (shouldFocus) trigger.focus();

      panel.querySelectorAll('carousel-slider').forEach((carousel) => {
        if (carousel.refresh && carousel.offsetParent) carousel.refresh();
      });
    }
  }

  customElements.define('tabbed-image-carousel', TabbedImageCarousel);
}
